import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"


import { storeToRefs } from 'pinia';
import { defineComponent, ref, onMounted } from 'vue';
// eslint-disable-next-line import/no-cycle
import { useAuthStore } from '@/store/auth/authModule';

const __default__ = { name: 'AppListView' };

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

onMounted(() => {
  console.log('AppListView mounted');
});

const store = useAuthStore();
const { getAvailableApps } = storeToRefs(store);

const goToLKTest = () => {
  window.open('https://ecohospital.ru/redirect-login', '_blank');
};
const goToDevPro = () => {
  window.open('https://dev.medsafe.pro/redirect-login', '_blank');
};
const goToDevDoctor = () => {
  window.open('https://dev.medsafe.doctor/#/redirect-login', '_blank');
};

return (_ctx: any,_cache: any) => {
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createVNode(_component_q_list, {
      bordered: "",
      separator: ""
    }, {
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createBlock(_component_q_item, { clickable: "" }, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, { onClick: goToLKTest }, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                _createTextVNode(" ECOHOSPITAL ", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        })), [
          [_directive_ripple]
        ]),
        _withDirectives((_openBlock(), _createBlock(_component_q_item, { clickable: "" }, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, { onClick: goToDevPro }, {
              default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                _createTextVNode(" DEV Medsafe PRO ", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        })), [
          [_directive_ripple]
        ]),
        _withDirectives((_openBlock(), _createBlock(_component_q_item, { clickable: "" }, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, { onClick: goToDevDoctor }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createTextVNode(" DEV Medsafe DOCTOR ", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        })), [
          [_directive_ripple]
        ])
      ]),
      _: 1
    })
  ]))
}
}

})